<template>
    <div>
        <ul class="tabs">
            <li v-for="(item, index) in tabList" :key="item.value" :class="index == titleShow ? 'tabsActive':''" @click="clickTab(index, item.value)">{{item.title}}</li>
        </ul>
    </div>
</template>

<script>
export default {
    props: {
        tabList: {
            type: Array,
            default: []
        }
    },
    data() {
        return {
            titleShow: 0
        }
    },
    methods: {
        clickTab(index, val) {
            this.titleShow = index;
            this.$emit('on-tab-change', val);
        }
    }
}
</script>

<style lang="scss" scoped>
.tabs {
    width: 100%;
    height: 37px;
    border: 1px solid #cacaca;
    line-height: 37px;
    text-align: center;
    box-sizing: border-box;
    li {
        width: 115px;
        height: 100%;
        float: left;
        font-weight: bold;
        cursor: pointer;
        -moz-user-select: none; /*火狐*/
        -webkit-user-select: none; /*webkit浏览器*/
        -ms-user-select: none; /*IE10*/
        -khtml-user-select: none; /*早期浏览器*/
        user-select: none;
    }
    .tabsActive {
        background: #ff9000;
        color: #fff;
    }
}
</style>